/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import DefaultDownpaymentAmount from './DefaultDownpaymentAmount/index'
import DefaultPayorSchedule from './DefaultPayorSchedule/index'
import IsFinancialsManagedExternally from './IsFinancialsManagedExternally/index'
import MaximumPaymentPlanLength from './MaximumPaymentPlanLength/index'
import MinimumDownpaymentAmount from './MinimumDownpaymentAmount/index'
import MonthDays from './MonthDays/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Financials"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Choose this if your financials are handled outside of Greyfinch."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<IsFinancialsManagedExternally
  viewPath={`${viewPath}/IsFinancialsManagedExternally`}
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceL}
 text="Downpayment"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Set a default downpayment and/or the minimum downpayment your clinic accepts (if any)."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<MinimumDownpaymentAmount
  viewPath={`${viewPath}/MinimumDownpaymentAmount`}
/>
<DefaultDownpaymentAmount
  viewPath={`${viewPath}/DefaultDownpaymentAmount`}
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 marginTop={dtSpaceL}
 text="Payment plans"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Define sensible defaults relating to the payment plan (amount, number of installments and payment frequencies)."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical2}`}
>
<MaximumPaymentPlanLength
  viewPath={`${viewPath}/MaximumPaymentPlanLength`}
/>
<DefaultPayorSchedule
  viewPath={`${viewPath}/DefaultPayorSchedule`}
/>
<MonthDays
  viewPath={`${viewPath}/MonthDays`}
/>
</div>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}